import React from 'react';
import { twMerge } from 'tailwind-merge';

import type { ThumbnailMetadata } from '../utils/videoUtils';

interface ThumbnailProps {
  thumbnail: ThumbnailMetadata;
  /** Blob URL from canvas extraction. When set, renders an <img>. */
  imageSrc?: string | null;
  /** Original video URL. Used as fallback when canvas extraction fails. */
  videoSrc?: string;
  className?: string;
}

export default function Thumbnail({
  thumbnail,
  imageSrc,
  videoSrc,
  className,
}: ThumbnailProps) {
  if (imageSrc) {
    return (
      <img
        className={twMerge(
          'flex-shrink-0 object-cover select-none pointer-events-none',
          className
        )}
        style={{ width: thumbnail.width, height: thumbnail.height }}
        src={imageSrc}
        draggable={false}
        alt=""
        onError={() => {
          console.error('Error loading thumbnail image', imageSrc, thumbnail);
        }}
      />
    );
  }

  if (videoSrc) {
    return (
      <video
        className={twMerge(
          'flex-shrink-0 object-cover select-none pointer-events-none',
          className
        )}
        style={{ width: thumbnail.width, height: thumbnail.height }}
        src={videoSrc}
        crossOrigin="anonymous"
        muted
        playsInline
        preload="metadata"
        draggable={false}
        onLoadedMetadata={(e) => {
          e.currentTarget.currentTime = thumbnail.timeInSeconds;
        }}
        onError={() => {
          console.error('Error loading thumbnail', videoSrc, thumbnail);
        }}
      />
    );
  }

  return (
    <div
      className="flex-shrink-0 bg-gray-700 animate-pulse select-none pointer-events-none"
      style={{ width: thumbnail.width, height: thumbnail.height }}
    />
  );
}
